module.exports = __webpack_public_path__ + "media/images/tailwind/download-dd67c4fd9ac537a5544bd665d0722ac0.png";